import React from 'react';
import PropTypes from 'prop-types';
import Body from './body';
import Header from './header';
import Modal from 'components/utils/modal';
import './styles.scss';

const propTypes = { handleClose: PropTypes.func };

const defaultProps = { handleClose: () => {} };

const Summary = ({ handleClose }) => {
  return (
    <Modal onClose={handleClose} className="summary-modal">
      <Header />
      <Body />
    </Modal>
  );
};

Summary.propTypes = propTypes;
Summary.defaultProps = defaultProps;

const areEqual = () => true;

export default React.memo(Summary, areEqual);
